module.exports = __webpack_public_path__ + "img/demo-photo10.23e0da68.jpg";